/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './scss/app.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './betalabs-analytics/betalabs-analytics.component.ngfactory';
import * as i3 from '../../app/betalabs-analytics/betalabs-analytics.component';
import * as i4 from '@angular/router';
import * as i5 from '../../app/app.component';
import * as i6 from '../../app/shared/services/google-analytics.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'betalabs-analytics',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_BetalabsAnalyticsComponent_0,
      i2.RenderType_BetalabsAnalyticsComponent)),i1.ɵdid(1,49152,(null as any),0,i3.BetalabsAnalyticsComponent,
      ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(3,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,4,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,49152,(null as any),0,i5.AppComponent,[i6.GoogleAnalyticsService],
          (null as any),(null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i5.AppComponent> = i1.ɵccf('app-root',
    i5.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjAzMjkyODc1MC9zcmMvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjAzMjkyODc1MC9zcmMvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmMyMDMyOTI4NzUwL3NyYy9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjAzMjkyODc1MC9zcmMvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxiZXRhbGFicy1hbmFseXRpY3M+PC9iZXRhbGFicy1hbmFseXRpY3M+XG48cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzhDQUFBLFVBQUE7TUFBQSwyQ0FBeUM7TUFBQSxTQUN6QztNQUFBO2FBQUE7MERBQUE7VUFBQTtJQUFBOzs7O29CQ0RBO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/$$_gendir/app/app.component.ngfactory.ts